import { gql } from "@apollo/client";
import { lensCompoundIdFragment } from "./lensCompoundIdFragment";

export const globalLensFragmentV2 = gql`
    fragment GlobalLensFragmentV2 on LensWithConnections {
        lens {
            updatedAt {
                seconds
            }
            iconUrl
            previewUrl
            videoUrl
            previewWebpUrl
            name
            vendorData {
                key
            }
            labels {
                key
                value
            }
            lensSourceInfo {
                name
            }
            minSdkVersion
            minWebSdkVersion
            lensStatus
            hasMusic
            ...LensCompoundId
        }
        connections {
            connectionId
            group {
                id
                name
            }
        }
    }
    ${lensCompoundIdFragment}
`;
